import React from 'react';
import {connect} from 'react-redux';
import {justifyMessage} from '../../redux/messages/actions';
import moment from 'moment';


/* Liste des alertes affichée au dessus de la carte en plein écran */
@connect(
  state => ({groomers: state.groomers}),
  {}
)
export default class extends React.Component {

  constructor() {
    super();
    this.state = {
      selectedGroomer: ''
    }
  }

  selectGroomer(event) {
    let value = event.target.value;
    console.log(value);
    if(value === '' || value === undefined || value === null) {
      this.setState({selectedGroomer: ''});
    } else {
      this.setState({selectedGroomer: value});
    }
  }

  render() {
    let {alerts, groomers, resort} = this.props;

    var selectedGroomer = '';

    return (
      <ul className="alerts-list">
        <div className="title">
          <span>Liste des alertes {this.state.selectedGroomer}</span>
          <div className="groomer-selector">
            <div className="r-field">
            <select name='groomerSelector' value={this.state.selectedGroomer} onChange={this.selectGroomer.bind(this)}>

              <option value="">Toutes les dameuses</option>
              { groomers.items.map(a => {

                return (
                  <option value={a.code}  >{a.code}</option>
                )
              })}
            </select>
            </div>
          </div>
        </div>
        {alerts.sort((a,b) => moment(a.datetimeReceived) < moment(b.datetimeReceived))
          .filter(a => {
            return a.groomerCode === this.state.selectedGroomer || this.state.selectedGroomer === ''
          })
          .map(a => {
          return (
            <AlertItem
              key={a.id}
              alert={a}
              resort={resort}
              groomer={ groomers.items.get(a.groomer_id) }/>
          );
        })}
      </ul>
    );
  }
}


/** Element Alerte de la liste des alertes */
@connect(
  state => ({}),
  {justifyMessage}
)
class AlertItem extends React.Component {
  constructor() {
    super();
    this.state = {
      justification: ''
    }
  }

  justifyAlert(event) {
    console.log(event.target.value);
    this.setState({justification: event.target.value});
    this.props.alert.justification = event.target.value;
    this.props.justifyMessage(this.props.alert);
  }

  render() {
    const {alert, resort} = this.props;
    if (alert.justification === null || alert.justification === undefined) {
      alert.justification = "";
    }
    let ulClassname="";
    if(resort.messageJustificationFeature) {
      ulClassname+="alertFeatureOn"
    } else {
      ulClassname+="alertFeatureOff"
    }
    const position = alert.latitude ?
      `${parseFloat(alert.latitude).toFixed(6)}, ${parseFloat(alert.longitude).toFixed(6)}` : '--';
    return (
      <li>
        <ul className={ulClassname}>
          <li><i className="mi mi-place"/></li>
          <li>{alert.groomerCode ? alert.groomerCode : '-'}</li>
          <li>{position}</li>
          <li>{alert.message}</li>
          <li>{alert.details ? alert.details : '-'}</li>
          <li>{alert.beacon ? alert.beacon : '-'}</li>
          <li>{alert.datetimeReceived}</li>
          {resort.messageJustificationFeature === true ? <li>
            <div className="r-field">
              <select value={alert.justification} onChange={this.justifyAlert.bind(this)}>
                <option value="">Pas de justification</option>
                <option value="groomer-snow-removal">Déneigement machine</option>
                <option value="trigger">Déclenchement</option>
                <option value="packing-plan">Plan damage</option>
                <option value="hydraulic-failure">Panne hydraulique</option>
                <option value="winch-failure">Panne treuil</option>
                <option value="groomer-overheat">Chauffe machine</option>
                <option value="mechanical-failure">Problème mécanique</option>
                <option value="fuel">Carburant</option>
                <option value="mechanic">Mecano</option>
                <option disabled value="other">Autre</option>
              </select>
            </div>
          </li>: null}
        </ul>
      </li>
    )

  }
}




// WEBPACK FOOTER //
// ./src/components/alerts/AlertsList.js